import React, { type ReactNode, type FC } from 'react';
import cx from 'classnames';

import { type WithOptionalDataTest } from 'types';
import styles from './content.module.scss';

export namespace Content {
  export type Props = {
    children?: ReactNode;
    className?: string;
    hasContainer?: boolean;
    fullHeight?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { className, hasContainer, fullHeight, children } = props;

    return (
      <div className={cx(styles.content, fullHeight && styles.content_fullHeight, className)}>
        {hasContainer ? <div className={styles.content__container}>{children}</div> : children}
      </div>
    );
  };
}
